import * as React from 'react';

import { IDocument } from '../../../../infrastructure/interfaces';

export interface SettingNavProps {
  cancel: any;
  document: IDocument;
  onSave(): void;
}


export default class SettingNav extends React.Component<SettingNavProps, any> {
  constructor(props: SettingNavProps) {
    super(props);
    this.state = {
      show: false,
      showInfo: false,
      isRequire: false
    };
    this.handleOpenInfo = this.handleOpenInfo.bind(this);
  }

  checkInformation() {
    let result = true;
    const companyInfo = this.props.document.companyInfo;
    for (const key in companyInfo) {
      if (typeof companyInfo[key] === 'string' && !companyInfo[key]) {
        result = false;
        break;
      }
    }
    return result;
  }

  handleSave = () => {
    if (!this.checkInformation()) {
      this.setState({
        showInfo: true,
      });
    }

    this.props.onSave();
  }

  handleCancel() {
    this.props.cancel();
  }

  handleOpenInfo = () => {
    this.setState({
      showInfo: true,
    });
  }

  render() {
    return (
      <div className="settingsButtonContainer">
        <div>
          <button className="settingsButton settingsCancelButton" onClick={this.props.cancel}>
            Cancel
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
          <button className="settingsButton settingsSaveButton" onClick={this.handleSave}>
            Save Options
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/SettingsNav.tsx